import { render, staticRenderFns } from "./ListMesaVotacionUsuario.vue?vue&type=template&id=6afa4b36&"
import script from "./ListMesaVotacionUsuario.vue?vue&type=script&lang=js&"
export * from "./ListMesaVotacionUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports